import _ from 'lodash';

/*
    removeStorage: removes a key from localStorage and its sibling expiracy key
    params:
        key <string>     : localStorage key to remove
    returns:
        <boolean> : telling if operation succeeded
*/
export function removeStorage (key) {
    try {
        localStorage.setItem(key, '');
        localStorage.setItem(`${key}_expiresIn`, '');
    }
    catch (e) {
        // eslint-disable-next-line no-console
        console.log(`removeStorage: Error removing key [${key}] from localStorage: ${JSON.stringify(e)}`);
        return false;
    }
    return true;
}

/*
    getStorage: retrieves a key from localStorage previously set with setStorage().
    params:
        key <string> : localStorage key
    returns:
        <string> : value of localStorage key
        null : in case of expired key or failure
*/
export function getStorage (key) {
    // epoch time, lets deal only with integer
    const now = Date.now();
    // set expiration for storage
    let expiresIn = localStorage.getItem(`${key}_expiresIn`);
    if (expiresIn === undefined || expiresIn === null) {
        expiresIn = 0;
    }

    expiresIn = Math.abs(expiresIn);
    if (expiresIn < now) {
        // Expired
        removeStorage(key);
        return null;
    }
    else {
        try {
            const value = localStorage.getItem(key);
            return value;
        }
        catch (e) {
            // eslint-disable-next-line no-console
            console.log(`getStorage: Error reading key [${key}] from localStorage: ${JSON.stringify(e)}`);
            return null;
        }
    }
}

/*
    setStorage: writes a key into localStorage setting a expire time
    params:
        key <string>     : localStorage key
        value <string>   : localStorage value
        expires <number> : number of seconds from now to expire the key
    returns:
        <boolean> : telling if operation succeeded
*/
export function setStorage (key, value, expires) {
    if (expires === undefined || expires === null) {
        // default: seconds for 1 day
        expires = 24 * 60 * 60;
    }

    // millisecs since epoch time, lets deal only with integer
    const now = Date.now();
    const schedule = now + expires * 1000;
    try {
        localStorage.setItem(key, value);
        localStorage.setItem(`${key}_expiresIn`, schedule);
    }
    catch (e) {
        // eslint-disable-next-line no-console
        console.log(`setStorage: Error setting key [${key}] in localStorage: ${JSON.stringify(e)}`);
        return false;
    }
    return true;
}

/**
 * Add or create storage to an Object
 * @param {String} key
 * @param {Object} value object
 * @param {Integer} expires
 * @returns void
 */
export function addStorage (key, value, expires) {
    if (expires === undefined || expires === null) {
        // default: seconds for 1 day
        expires = 24 * 60 * 60;
    }

    // millisecs since epoch time, lets deal only with integer
    const now = Date.now();
    const schedule = now + expires * 1000;
    try {
        let currentStorage = getStorage(key);
        const isCurrentStorageObject = currentStorage.startsWith('{') && currentStorage.endsWith('}');
        const isValueObject = value instanceof Object;

        // si el storage es object y el value es object unirlo
        if (isCurrentStorageObject && isValueObject) {
            currentStorage = _.defaultsDeep({}, JSON.parse(currentStorage), value);
        }
        else {
            currentStorage = value;

            /*
            if (isCurrentStorageObject || isValueObject) {
            // si el storage es object y el value no es object dejar el value
            // si el storage No es object y el value es object dejar el value
                currentStorage = value;
            }
            else {
            // si el storage No es object y el value no es object dejar el value
                currentStorage = value;
            }
            */
        }

        currentStorage = currentStorage instanceof String ? currentStorage : JSON.stringify(currentStorage);

        localStorage.setItem(key, currentStorage);
        localStorage.setItem(`${key}_expiresIn`, schedule);
    }
    catch (e) {
        // eslint-disable-next-line no-console
        console.log(`setStorage: Error setting key [${key}] in localStorage: ${JSON.stringify(e)}`);
        return false;
    }
    return true;
}

export function getStoreByStorage () {
    const store = JSON.parse(localStorage.getItem('store'));
    return store;
}

export function getSessionUserByStorage () {
    const sessionUser = JSON.parse(localStorage.getItem('sessionUser'));
    return sessionUser;
}
